module.exports = __webpack_public_path__ + "img/ep7-5b.1d797641.png";